<template>
    <div class="knowledge-book-article">
        <TextReading ref="textReading"
                     :article-detail="detailData"
                     :collect-handler="collect"
                     :collect-status="detailData.follow_state === '1'"
                     :chapter-change-handler="chapter"
                     :limit-id="limitId"
                     :has-print="true"
                     :hide-toggle="true"
        >
            <div class="nav-wrap">
                <div class="subscribe-card-wrap">
                    <div class="subscribe-card">
                        <div class="cover hb-resource-cover">
                            <img v-if="baseData"
                                 :src="baseData.poster"
                            >
                        </div>
                        <div class="infos">
                            <h4 class="text1line">
                                {{ langTransfer(baseData.name) }}
                            </h4>
                            <div v-show="webInfo.isAllowLogin == '1' && baseData.name"
                                 class="subscribe-btn-wrap lr-img-scale"
                                 @click="addFocus"
                            >
                                <LottieAddBtn
                                    :is-collection="baseData.follow_state === '1'"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="catelog-mask">
                    <div class="tab-wrap">
                        <div v-for="(item) in baseData.chapterList"
                             :key="item.id"
                             class="tab-item"
                             :class="{'checked-tab-item': $route.params.catalogId === item.id}"
                             @click="tabClickHandler(item.id)"
                        >
                            {{ item.name }}
                        </div>
                    </div>
                    <bscroll-view ref="catalogBScroll"
                                  hide-scroll-bar
                                  :pull-up-handler="loadMore"
                    >
                        <div class="catelog-list">
                            <div v-for="(item, index) in menuList"
                                 :key="index"
                                 class="cate-item"
                                 :style="{'font-weight': $route.params.id === item.id ? '600' :'',
                                          color: $route.params.id === item.id ? '#303133' :''}"
                                 @click="subCateClick(item.id)"
                            >
                                {{ langTransfer(item.title) }}
                            </div>
                        </div>
                    </bscroll-view>
                </div>
            </div>
        </TextReading>
    </div>
</template>
<script>
    import TextReading from '@/components/textReading'
    import LottieAddBtn from '@/components/lottieActions/add'
    import BscrollView from '@/components/bscrollView'
    import {
        detail
    } from '../../api/lyl'
    import { knowledgeBookCate, getKonwledgeArticle } from '../../api/hb'

    export default {
        name: 'LevelFourCatalog',
        components: {
            TextReading,
            LottieAddBtn,
            BscrollView,
        },
        data () {
            return {
                baseData: {},
                detailData: {},
                menuList: [],
                limitId: {
                    start: '',
                    end: ''
                },
                currentId: '',
                getAll: false
            }
        },
        computed: {
            pageSetup () {
                return this.$store.state.pageSetup
            },
            user_unique_code () {
                return this.$store.state.user_unique_code
            },
            webInfo () {
                return this.$store.state.webInfo
            }
        },
        watch: {
            webInfo (newVal) {
                if (newVal.service_code) {
                    this.getBookDetail()
                    const { catalogId, id } = this.$route.params
                    if (catalogId) {
                        this.getCatelog()
                    }
                    if (id) {
                        this.getArticle(id)
                    }
                }
            }
        },
        methods: {
            tabClickHandler (catalogId) {
                this.$router.push({
                    params: {
                        catalogId,
                        id: undefined
                    }
                })
            },
            addFocus () {
                const formData = {
                    type: 12,
                    res_code: this.$route.params.resId
                }
                const callback = (bool) => {
                    if (bool) {
                        this.baseData.follow_state = '2'
                    } else {
                        this.baseData.follow_state = '1'
                    }
                }
                this.$utils.userCollect(formData, callback)
            },
            chapter (isPrev) {
                const { menuList } = this
                const { id } = this.$route.params
                let newItem
                const currentIndex = menuList.findIndex((e) => {
                    return e.id === id
                })
                if (isPrev) {
                    newItem = menuList[currentIndex - 1]
                } else {
                    newItem = menuList[currentIndex + 1]
                }
                if (!newItem) {
                    return
                }
                this.subCateClick(newItem.id)
            },
            subCateClick (id) {
                this.$router.push({
                    params: {
                        id
                    }
                })
            },
            async getBookDetail () {
                try {
                    const { resId: id } = this.$route.params
                    const data = await detail({
                        service_code: this.webInfo.service_code,
                        type: '8',
                        id,
                        user_unique_code: this.user_unique_code
                    })
                    this.baseData = data
                    if (!this.$route.params.catalogId && this.menuList.length <= 0) {
                        this.tabClickHandler(data.chapterList[0].id)
                    }
                } catch (err) {
                    console.log(err)
                }
            },
            loadMore (bscrollObj) {
                if (this.getAll) {
                    return
                }
                const newPage = Math.ceil(this.menuList.length / 15) + 1
                this.getCatelog(undefined, newPage, bscrollObj)
            },
            async getCatelog (newId, page = 1, bscrollObj) {
                try {
                    const { catalogId: id } = this.$route.params
                    const { webInfo } = this
                    let { records: data } = await knowledgeBookCate({
                        service_code: webInfo.service_code,
                        id: newId || id,
                        page,
                        pageSize: 15
                    })
                    const { readStatus } = this.webInfo
                    if (Number(readStatus) !== 2) {
                        data = data.slice(0, 3)
                        this.getAll = true
                    }
                    if (data.length < 15) {
                        this.getAll = true
                    }
                    if (page !== 1) {
                        this.menuList = this.menuList.concat(data)
                        this.setLimitId()
                        if (bscrollObj) {
                            bscrollObj.finishPullUp()
                        }
                        return
                    }

                    this.menuList = data
                    this.setLimitId()
                    if (!this.$route.params.id && !this.detailData.content) {
                        this.subCateClick(this.menuList[0].id)
                    }
                } catch (err) {
                    if (err.code === '-1') {
                        this.getAll = true
                    }
                    console.log(err)
                }
            },
            setLimitId () {
                const { menuList, getAll } = this
                this.limitId = {
                    start: menuList[0].id,
                    end: getAll ? menuList[menuList.length - 1].id : -1
                }
                if (getAll) {
                    return
                }

                const { id } = this.$route.params
                if (!id) {
                    return
                }
                const hasCurrent = menuList.findIndex((e) => {
                    return e.id === id
                }) !== -1
                if (!hasCurrent) {
                    this.loadMore()
                }
            },
            async getArticle (id) {
                try {
                    const data = await getKonwledgeArticle({
                        service_code: this.webInfo.service_code,
                        type: 8,
                        id,
                        user_unique_code: this.user_unique_code
                    })
                    this.detailData = data
                } catch (err) {
                    console.log(err)
                }
            },
            collect () {
                const { id: res_code } = this.$route.params
                const formData = {
                    type: 13,
                    res_code
                }
                const callback = (bool) => {
                    if (bool) {
                        this.detailData.follow_state = '2'
                    } else {
                        this.detailData.follow_state = '1'
                    }
                }
                this.$utils.userCollect(formData, callback)
            }
        },
        beforeRouteUpdate (to, from, next) {
            const { catalogId, id } = to.params
            if (catalogId) {
                this.getAll = false
                this.getCatelog(catalogId)
            }
            if (id) {
                this.getArticle(id)
            }
            const { bscrollObj } = this.$refs.catalogBScroll
            if (bscrollObj) {
                bscrollObj.finishPullUp()
                bscrollObj.scrollTo(0, 0)
            }
            const { contentBScrollObj } = this.$refs.textReading
            if (contentBScrollObj) {
                contentBScrollObj.finishPullUp()
                contentBScrollObj.scrollTo(0, 0)
            }
            next()
        },
        beforeRouteEnter: (to, from, next) => {
            next((vm) => {
                const { service_code } = vm.webInfo
                if (service_code) {
                    vm.getBookDetail()
                    const { catalogId, id } = to.params
                    if (catalogId) {
                        vm.checkedTab = catalogId
                        vm.getCatelog()
                    }
                    if (id) {
                        vm.getArticle(id)
                    }
                }
            })
        }
    }
</script>

<style scoped lang="less">
    .knowledge-book-article {
        width: 100%;
        height: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
    }

    .nav-wrap {
        width: 100%;
        height: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
    }

    .subscribe-card-wrap {
        width: 300px;
        height: 126px;
        box-sizing: border-box;
        padding: 20px;
        background: #F5F7FA;
        border-radius: 8px 8px 0px 0px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
    }

    .subscribe-card {
        width: 100%;
        height: 100%;
        flex-shrink: 0;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .cover {
            width: 72px;
            height: 96px;
            box-sizing: border-box;
            border-radius: 4px;
            cursor: auto;
            margin-right: 10px;
        }

        .infos {
            height: 96px;
            flex: 1;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            align-items: flex-start;

            h4 {
                max-height: 48px;
                font-size: 18px;
                font-family: AlibabaPuHuiTiM;
                color: #303133;
                line-height: 24px;
                user-select: none;
                margin-bottom: 12px;
            }
        }
    }

    .subscribe-btn-wrap {
        width: 80px;
        height: 36px;
        overflow: hidden;
        background: #303133;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
        border-radius: 18px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        user-select: none;
    }

    .catelog-mask {
        width: 100%;
        flex: 1;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;

        .tab-wrap {
            width: 100%;
            height: 34px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px 0;
            box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);

            .tab-item {
                width: fit-content;
                padding: 5px 10px;
                margin-right: 10px;
                font-size: 15px;
                font-family: AlibabaPuHuiTiM;
                color: #909399;
                line-height: 24px;
                cursor: pointer;
                user-select: none;
                white-space:nowrap;

                &:last-child {
                    margin-right: 0;
                }
            }

            .checked-tab-item {
                color: #303133;
                // background: #FFFFFF;
                // box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
            }

        }
    }

    .catelog-list {
        width: 100%;
        box-sizing: border-box;
        padding: 0 20px 30px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;

        .cate-item {
            width: 100%;
            padding: 20px 0 10px;
            font-size: 14px;
            font-family: AlibabaPuHuiTiR;
            color: #606266;
            line-height: 20px;
            border-bottom: 1px solid #f1f1f1;
            cursor: pointer;
            user-select: none;

            &:last-child {
                border-bottom: none;
            }
        }

        .cate-item-name {
            width: 100%;
            font-size: 13px;
            font-family: AlibabaPuHuiTiM;
            color: #909399;
            line-height: 20px;
        }

        .sub-list {
            width: 100%;
            margin-top: 10px;
        }

        .sub-item {
            margin-bottom: 20px;

            &:last-child {
                margin-bottom: 0;
            }

            &:hover {

                .sub-item-name {
                    color: #303133;
                }

                .sub-item-summary {
                    color: #606266;
                }
            }
        }

        .sub-item-name {
            width: 100%;
            font-size: 15px;
            font-family: AlibabaPuHuiTiM;
            color: #606266;
            line-height: 24px;
        }

        .sub-item-summary {
            width: 100%;
            font-size: 13px;
            font-family: AlibabaPuHuiTiR;
            color: #909399;
            line-height: 20px;
            max-height: 40px;
        }
    }

    .recommend-article-wrap {
        width: 740px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;

        .header-wrap {
            width: 100%;
            height: 36px;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            user-select: none;
            position: relative;
            z-index: 2;
            background: #fff;

            h5 {
                width: fit-content;
                height: 36px;
                box-sizing: border-box;
                padding: 10px 20px;
                font-size: 16px;
                font-family: AlibabaPuHuiTiB;
                color: #303133;
                line-height: 16px;
                background: #FFFFFF;
                box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
            }

            &::after {
                content: "";
                display: block;
                flex: 1;
                height: 4px;
                background: #F0F2F5;
            }
        }

        .list-wrap {
            width: 100%;
            margin: 20px 0 30px;

            .item {
                width: 100%;
                margin-bottom: 22px;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: flex-start;
                cursor: pointer;

                &:nth-child(2n) {
                    margin-right: 0;
                }

                &:hover {

                    h6,.other-info {
                        color: #303133;
                    }

                    p {
                        color: #606266;
                    }
                }
            }

            .infos {
                flex: 1;

                h6 {
                    font-size: 18px;
                    font-family: AlibabaPuHuiTiM;
                    color: #606266;
                    line-height: 24px;
                }

                p {
                    max-height: 40px;
                    font-size: 13px;
                    font-family: AlibabaPuHuiTiR;
                    color: #909399;
                    line-height: 20px;
                    margin: 6px 0 12px;
                }

                .other-info {
                    font-size: 13px;
                    font-family: AlibabaPuHuiTiM;
                    color: #606266;
                    line-height: 20px;
                }
            }

            .hb-resource-cover {
                width: 104px;
                height: 104px;
                border-radius: 8px;
                margin-left: 20px;
            }
        }
    }
</style>
